<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="productFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                productFileForm: () => import('../forms/ProductFileForm'),
                headers: [
                    { text: 'Product', value: 'productId', table: 'products', form: () => import('../forms/ProductForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    products: [],
                    items: []
                },
                sorting: [
                    { column: "productId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'productFiles',
                editPageName: 'productFile',
                apiMethod: 'ProductFiles',
                claimName: 'ProductFiles',
                formTitle: 'Product File',
                excelTitle: 'Product Files',
                hasEditPage: false,
            }
        },
    };
</script>
